import { DatePickerInput, DatePickerInputProps } from '@/components/content/DatePicker/DatePickerInput'
import styled from 'styled-components'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '@/utils/consts'
import { useState } from 'react'
import DatePickerUtils from '@/components/content/DatePicker/DatePickerUtils'

interface MonthDatePickerProps {
  value: string
  onChange: (value: string | Date | null) => void
  maxDate?: Date
  minDate?: Date
  format?: string
  inputWidth?: number
  size?: 'sm' | 'md' | 'lg'
  fixedCalendar?: boolean
}

const CustomDatePickerInput = styled(DatePickerInput)<{ width?: number }>`
  width: ${({ width }) => width && `${width}px`} !important;
`

// MEMO: 우선 월 고정 캘린더만 사용되어 커스텀하게 handleViewChange 구현하였습니다. 이후에 추가적인 요구사항 있으면 더 확장성 있게 리팩터링(+리네이밍) 필요합니다.
export function MonthDatePicker({
  value,
  onChange,
  size,
  minDate,
  maxDate = dayjs().toDate(),
  format = 'yyyy-MM',
  inputWidth,
  fixedCalendar = false,
}: MonthDatePickerProps) {
  const [datePickerView, setDatePickerView] = useState<DatePickerInputProps['view']>('year')

  const handleViewChange = ({ view }: { view: DatePickerInputProps['view'] }) => {
    if (view !== 'month') {
      setDatePickerView(view)
      return
    }
    setTimeout(() => {
      DatePickerUtils.onForceToClose('simple', 'react-datetime-picker__calendar')
    }, 0)
  }

  const handleClickMonth = (value: Date) => {
    onChange(dayjs(value).format(DATE_FORMAT.dateMonth))
  }

  return (
    <CustomDatePickerInput
      size={size}
      value={value}
      view={datePickerView}
      format={format}
      minDate={minDate}
      maxDate={maxDate}
      fixedCalendar={fixedCalendar}
      onClickMonth={handleClickMonth}
      onViewChange={handleViewChange}
      width={inputWidth}
    />
  )
}
